/*
    This file contains all the URLS belong to User Management menu
*/

// Menu keys
import { MENU_KEYS } from "@Vytelle/admin/src/constants/ApplicationMenuConstants";

const KEY = MENU_KEYS.USER;

// User params
export const USER_PARAMS = {
  USER_ID: ":userId",
};

export const USER_URLS = {
  /* TRIAL URLS   */
  USER_LIST: KEY + "/list", // User Listing
  USER_DETAIL: KEY + `/detail/${USER_PARAMS.USER_ID}`, // User Detail
  CREATE_USER: KEY + "/create", // Create User
  UPDATE_USER: KEY + `/edit/${USER_PARAMS.USER_ID}`, // Update User

  SETTINGS: KEY + `/settings`, // Settings

  SIGN_UP: KEY+ "/sign-up", // Sign Up User
};
